var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyPaste = function SvgCopyPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 39"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0H15.6c-1.1 0-2 .9-2 2v11.7H2c-1.1 0-2 .9-2 2V37c0 1.1.9 2 2 2h21.4c1.1 0 2-.9 2-2V25.4H37c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM21.6 35.1H3.9V17.5h9.8v5.9c0 1.1.9 2 2 2h5.9v9.7zM35 21.5H17.5V3.9H35v17.6zm-12.2-2.6 4.5-4.5v1.1c0 1.1.9 1.9 2 1.9s2-.9 2-1.9V9.8c0-1.1-.9-1.9-2-1.9h-5.9c-1.1 0-1.9.9-1.9 1.9s.9 1.9 1.9 1.9h1.1L20 16.2c-.8.8-.8 2 0 2.8.7.5 2.1.7 2.8-.1z"
  })));
};
export default SvgCopyPaste;